import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import { Link } from "@mui/material";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/X";
import { Instagram, Facebook } from "@mui/icons-material";
import { YouTube } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";

const logoStyle = {
  width: "100%",
  maxWidth: "200px", // For responsive scaling
  height: "auto",
};

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" mt={1}>
      {"Copyright © "}
      <Link href="https://nexensus.com/">Nexensus&nbsp;</Link>
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const navigate = useNavigate();
  const theme = useTheme();
  const logo =
    theme.palette.mode === "light" ? "logo_white.png" : "logo_black.png";

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 4, sm: 8 },
        py: { xs: 8, sm: 4 },
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          width: "100%",
          alignItems: { xs: "center", sm: "flex-start" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            alignItems: { xs: "center", sm: "flex-start" },
          }}
        >
          <Box sx={{ width: { xs: "150%", sm: "100%" } }}>
            <Box sx={{ ml: { sm: "-15px", xs: 0 } }}>
              <img
                src={require(`../img/${logo}`)}
                style={logoStyle}
                alt="logo of Check Before invest"
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: { xs: "center", sm: "space-between" },
            gap: { xs: 3, sm: 6 },
            textAlign: { xs: "center", sm: "left" },
            mt: { xs: 4, sm: 0 },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography variant="body2" fontWeight={600}>
              Product
            </Typography>
            <Link color="text.secondary" href="/pricing">
              Pricing
            </Link>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography variant="body2" fontWeight={600}>
              Company
            </Typography>
            <Link
              color="text.secondary"
              target="_blank"
              href="https://www.nexensus.com/aboutcompany"
            >
              About us
            </Link>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Link
              color="text.secondary"
              onClick={() => navigate("/terms-of-service")}
              sx={{ cursor: "pointer" }}
            >
              Terms of Service
            </Link>
            <Link
              color="text.secondary"
              onClick={() => navigate("/privacy")}
              sx={{ cursor: "pointer" }}
            >
              Privacy Policy
            </Link>
            <Link
              color="text.secondary"
              onClick={() => navigate("/contact-us")}
              sx={{ cursor: "pointer" }}
            >
              Contact
            </Link>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          pt: { xs: 4 },
          borderTop: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box>
          <Link
            color="text.secondary"
            onClick={() => navigate("/privacy")}
            sx={{ cursor: "pointer" }}
          >
            Privacy Policy
          </Link>
          <Typography display="inline" sx={{ mx: 0.5, opacity: 0.5 }}>
            &nbsp;•&nbsp;
          </Typography>
          <Link
            color="text.secondary"
            onClick={() => navigate("/terms-of-service")}
            sx={{ cursor: "pointer" }}
          >
            Terms of Service
          </Link>
          <Copyright />
        </Box>
        <Stack
          direction="row"
          justifyContent="center"
          spacing={1}
          sx={{ mt: { xs: 3, sm: 0 } }}
        >
          <IconButton color="inherit" target="_blank" href="https://www.facebook.com/nexensus" aria-label="Facebook">
            <Facebook fontSize="large" />
          </IconButton>
          <IconButton color="inherit" target="_blank" href="https://twitter.com/Nexensus" aria-label="X">
            <TwitterIcon fontSize="medium" />
          </IconButton>
          <IconButton color="inherit" target="_blank" href="https://www.linkedin.com/company/nexensus/" aria-label="LinkedIn">
            <LinkedInIcon fontSize="large" />
          </IconButton>
          <IconButton color="inherit" target="_blank" href="https://www.youtube.com/@nexensussupport476" aria-label="YouTube">
            <YouTube fontSize="large" />
          </IconButton>
        </Stack>
      </Box>
    </Container>
  );
}
